module.exports = __webpack_public_path__ + "media/packs/components/images/googleplay-86d7c8227ce71d8e5e8826125dfe5964.png";